import React from "react";
import "./Input.css";
function Input(props) {
  return (
    <div className="input-content">
      <div>
        <input
          type="text"
          id="input-text"
          value={props.currValue}
          placeholder="Write your todo here"
          onChange={props.handleUpdateTodoList}
        />
      </div>
      <div>
        <button id="btn" onClick={props.handleTodoList}>
          +Add
        </button>
      </div>
    </div>
  );
}

export default Input;
